import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import Doc from '@Components/PdfContainer/DocService';
import PdfContainer from '@Components/PdfContainer';
import LoadingSpinner from '../../components/LoadingSpinner';
import Contact from '../../components/Contact';
import Card from '../../components/Card';
import PdfNy from '../../components/Pdf/PdfNy';
import * as api from '../../utils/api';
import { TAllData, TInput, TRecommendations, TChapter } from '../../utils/types';
import Grid from '../../components/Grid';

export interface RecommendationsProps {
  resultatLink: string
  baseUrl: string
  phnNumber: string
  recommendationTextData: {
    BookingUrl: string
	formTitle:string
	formText: string
	formSubmittedText: string
	title: string,
    persondataLabel: string,
    velkomstEpiserverId: string
  }
  pensionsAlder: number
  fullData: TAllData
  erMedlem: boolean
  inputData: TInput
  objdata: {[name: string]: string}
  setInputData: (inputData: TInput) => void
}

const Recommendations = (props: RecommendationsProps) => {
	const { resultatLink, baseUrl, phnNumber, recommendationTextData, erMedlem, pensionsAlder } = props;
	const [isLoading, setIsLoading] = useState(true);
	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const createPdf = () => props.objdata['ServicetjekType'] === 'Velkomst' ? Doc.createPdf() : null;
	const [allData, setAllData] = useState<TChapter[]>();
	const [data, setData] = useState<TRecommendations>(
		{
			Title: '',
			Text: '',
			Anbefalinger: [],
			PhnNumber: phnNumber,
			PdfNavn: '',
			PdfText: '',
			PdfTitle: ''
		}
	);
	const { BookingUrl, title } = recommendationTextData;

	useEffect(() => {
		fetchRecommendations();
	}, []);

	useEffect(() => {
		if (pensionsAlder) {
			setIsDataLoaded(true);
		}
	}, [pensionsAlder]);

	const fetchRecommendations = async () => {
		setIsLoading(true);
		const data = await api.getRecommendationData(resultatLink, props.objdata ? props.objdata['ServicetjekType'] : '');
		setData(data);
		const allData = await api.getChaptersData(baseUrl, props.objdata['ServicetjekType']);
		setAllData(allData);
		setIsLoading(false);
	};

	const renderReceit = () => {
		return (
			<div className="content">
				<div className="content-richtext">
					{ data.Title && <h1 className="f34">{ data.Title }</h1> }
					{ data.Text && (
						<div className="receipt">
							{ parse(data.Text) }
						</div>
					) }
				</div>
				{ <div className="lhp-cards">
					{ data.Anbefalinger && data.Anbefalinger.map((card, i) => {
						return <Card key={ i } cardData={ card } />;
					}) }
				</div> }
			</div>
		);
	};

	const renderPDF = () => {
		if (isLoading) {
			return null;
		}

		return (
			<PdfContainer
				createPdf={ createPdf }
				buttonText=""
				successText=""
				autoSave
				apiUrl="/api/WebDokumentationApi/GemDokumentation"
				documentName={ data.PdfNavn }
			>
				<PdfNy
					title={ title }
					pensionsAlder={ pensionsAlder }
					recommendationsData={ data }
					introTitle={ data.PdfTitle }
					introText={ data.PdfText }
					phnNumber={ phnNumber }
					allData={ allData }
				/>

			</PdfContainer>
		);
	};

	if (isLoading) {
		return <LoadingSpinner />;
	}

	return (
		<>
			<Grid className="page grid recommendation new" mobileBlock>
				<Contact contactItems={ { booking: false, phn: true } } bookingUrl={ BookingUrl } phnNumber={ phnNumber } />
				{ renderReceit() }
			</Grid>
			{ erMedlem && isDataLoaded && props.objdata['ServicetjekType'] === 'Velkomst' && renderPDF() }
		</>
	);
};

export default Recommendations;